// 请求配置
import { ResponseCode } from '@/constants/code';
import { bridgeBootstrap, log } from '@/utils/bridge';
import { getLocale } from '@/utils/lang';
import { registerServiceWorker } from '@/utils/serviceWorkerUtils';
import { config, createErrorConfigs } from '@@/plugin-requestConfigs/configs';
import { createARMSInstance } from '@microbt/shared';
import pkg from '../package.json';
import './utils/gio';

registerServiceWorker();
bridgeBootstrap('h5mine');

export const request = {
  ...config,
  headers: {
    appKey: 'bjrD9M0V',
    utdId: 'superacme',
  },
  ...createErrorConfigs(
    {
      onTokenFailed: () => {
        console.log('onTokenFailed================');
        location.href = `${location.protocol}//${location.host.replace(
          'app',
          'mall',
        )}/login?redirect=${encodeURIComponent(location.href)}`;
      },
      onAccessDenied: () => console.log('onAccessDenied'),
      onErrorMessage: (msg) => console.log(msg),
      onTipMessage: (msg) => console.log(msg),
    },
    {
      isTokenFailed: (code) => {
        return [
          ResponseCode.TOKEN_EMPTY,
          ResponseCode.TOKEN_TIMEOUT,
          ResponseCode.TOKEN_CHECK_FAILURE,
        ].includes(code);
      },
      isAccessDenied: (code) => {
        return code === 1000002;
      },
      isTipMessage: (code) => {
        return code === 1001007;
      },
    },
  ),
};

const arms = createARMSInstance({
  pid: 'i9t36rh0bq@5a946b421a7a92c',
  release: `h5app_${pkg.version}`,
});

console.log('arms=========', arms);

export const locale = {
  getLocale,
};

// native 调用 h5 的方法
window.callJS = (functionName: string, payload?: string, callBack?: (result: any) => any) => {
  const res = window.toNative[functionName](payload ? JSON.parse(payload) : undefined);
  callBack?.(res);
  return res;
};

window.registerFn2Native = (functionName: string, fn: () => void) => {
  if (!window.toNative) {
    window.toNative = {};
  }
  window.toNative[functionName] = fn;
};

window.cancelFn2Native = (functionName: string) => {
  if (!window.toNative) {
    window.toNative = {};
  }
  delete window.toNative[functionName];
};

log(`H5MineAppStart: ${+new Date()}`);
